// extracted by mini-css-extract-plugin
export default {"paymentInfo":"paymentInfo__bvgLKP","iconActive":"iconActive__qDcRCp","iconFailed":"iconFailed__B_e7eY","iconButton":"iconButton__R0d1js"};